import { render, staticRenderFns } from "./ArtCard.vue?vue&type=template&id=ec2c9a52&scoped=true&"
import script from "./ArtCard.vue?vue&type=script&lang=js&"
export * from "./ArtCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtCard.vue?vue&type=style&index=0&id=ec2c9a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c9a52",
  null
  
)

export default component.exports